'use client';

import { RichTextField } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';
import classNames from 'classnames';
import { useState, useEffect } from 'react';
export interface TopBarProps {
    hasTopbar?: boolean;
    messages?: RichTextField[];
    background?: string;
}

const TopBar = ({
    messages = [
        [
            {
                type: 'paragraph',
                text: 'Free shipping | Certified Aussie Practitioners | 100% online',
                spans: [],
            },
        ],
    ],
    background,
}: TopBarProps) => {
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            if (messages.length <= 1) return;
            setIsTransitioning(true);
            setTimeout(() => {
                setCurrentMessageIndex(
                    (prevIndex) => (prevIndex + 1) % messages.length,
                );
                setIsTransitioning(false);
            }, 500);
        }, 9000);
        return () => clearInterval(interval);
    }, [messages.length]);

    return (
        <section
            className={classNames(
                'z-[1000] flex h-[51px] w-full justify-center overflow-hidden',
                `bg-${background}`,

                background === 'green-dark' ? 'text-white' : 'text-green-dark',
            )}
        >
            <div className="relative h-full w-full">
                {messages.map((message, index) => (
                    <div
                        key={index}
                        className={classNames(
                            'absolute flex h-full w-full items-center justify-center transition-transform duration-500 ease-in-out',
                            {
                                '-translate-y-full':
                                    index === currentMessageIndex &&
                                    isTransitioning,
                                '!translate-y-0':
                                    (index === currentMessageIndex &&
                                        !isTransitioning) ||
                                    messages.length === 1,
                                'translate-y-full':
                                    index ===
                                    (currentMessageIndex + 1) % messages.length,
                                hidden:
                                    index !== currentMessageIndex &&
                                    index !==
                                        (currentMessageIndex + 1) %
                                            messages.length,
                            },
                        )}
                    >
                        <PrismicRichText
                            field={message}
                            components={{
                                paragraph: ({ children }) => (
                                    <p className="p2 highlight text-center">
                                        {children}
                                    </p>
                                ),
                                hyperlink: ({ children, node }) => (
                                    <a
                                        className="p2 highlight text-center font-demi underline hover:underline"
                                        href={node.data.url}
                                    >
                                        {children}
                                    </a>
                                ),
                            }}
                        />
                    </div>
                ))}
            </div>
        </section>
    );
};

export default TopBar;
